import type { ComponentProps } from 'react'

import { cn } from '@/util/cn'

const VerticalDivider = ({ className, ...props }: ComponentProps<'div'>) => (
  <div className={cn('mx-1 md:mx-2 w-[2px] h-4 border-l border-l-rsf-grey-light', className)} {...props}></div>
)

export default VerticalDivider
